import React, { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";
import bg1 from "../../assets/images/bg/Events.jpg";
import bg from "../../assets/images/bg/Events-m.jpg";
import { doc, getDoc } from "firebase/firestore";
import { firestore } from "../../Config/FbConfig";

const EventDetails = () => {
  const navigate = useNavigate();
  let params = useParams();
  let id = params.id;
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true); // Loading state
  const data = events.find((event) => event.Id === id);
  const [bgImage, setBgImage] = useState(window.innerWidth <= 768 ? bg : bg1);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setBgImage(window.innerWidth <= 768 ? bg : bg1);
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [bg, bg1]);

  useEffect(() => {
    const fetch_3 = async () => {
      try {
        const docRef = doc(firestore, "Home", "Events");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          var Data = [];
          Object.entries(docSnap.data()).forEach(([key, value]) => {
            Data.push(Object.assign({ Id: key }, value));
          });
          setEvents(
            Data.sort(function (a, b) {
              return a.Priority - b.Priority;
            })
          );
        } else {
          setEvents([]);
        }
      } catch (error) {
        console.error("Error fetching events: ", error);
      } finally {
        setLoading(false); // Set loading to false after fetch completes
      }
    };
    fetch_3();
  }, [id]);

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "80vh",
        }}
      >
        <h4>Loading...</h4>
      </div>
    ); // Display loading indicator
  }

  if (!data) {
    return <div>No event details available</div>;
  }

  return (
    <div>
      <Navbar
        manuClass="navigation-menu nav-left nav-light"
        containerClass="container"
      />
      <section
        className="bg-half-170 d-table w-100"
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundPosition: "center",
        }}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12">
              <div className="section-title text-center">
                <h3 className="sub-title  text-white title-dark">
                  Ranga Bandi ~ Events
                </h3>
                <p className="para-desc mx-auto text-white-50">
                  Theatre is the heartbeat of culture, keeping history alive and
                  dreams vivid.
                </p>

                <nav aria-label="breadcrumb" className="d-inline-block">
                  <ul className="breadcrumb bg-light rounded mb-0 py-1 px-2">
                    <li className="breadcrumb-item">
                      <Link to="/">Home</Link>
                    </li>
                    <li style={{color:"#B9B569"}} className="breadcrumb-item active" aria-current="page">
                      Ranga Bandi ~ Events
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="container mt-4">
        <div style={{ marginBottom: "1.5rem" }}>
          <button
            style={{ backgroundColor: "#B9B568", border: "#B9B568" }}
            onClick={() => {
              navigate(-1);
            }}
            className="btn btn-primary"
          >
            Go Back
          </button>
        </div>
        <div className="card shadow-lg p-4 mb-5 bg-white rounded">
          <div className="card-body">
            <div style={{ display: "flex", justifyContent: "center" }}>
              <img
                src={data?.Image}
                className="img-fluid rounded shadow"
                alt=""
                style={{ height: "300px" }}
              />
            </div>

            <h3
              className="card-title  font-weight-bold"
              style={{
                fontSize: "1.5rem",
                marginTop: "2rem",
              }}
            >
              {data?.Header}
            </h3>

            <p
              className="card-text text-justify"
              style={{
                fontSize: "1rem",
                lineHeight: "1.5",
                marginTop: "2rem",
              }}
            >
              {data?.Description}
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default EventDetails;
